/**
 * AF-4082: prioridade ao consolidar o mesmo documento vindo de mais de um report.
 * REJECTED > ERROR > INTERRUPTED > PENDING > NO_DATA > APPROVED.
 */
export const mergeRecommendation = (existing: string, incoming: string): string => {
    if (incoming === 'REJECTED') return 'REJECTED';
    if (incoming === 'ERROR' && existing !== 'REJECTED') return 'ERROR';
    if (incoming === 'INTERRUPTED' && existing !== 'REJECTED' && existing !== 'ERROR') return 'INTERRUPTED';
    if (
        incoming === 'PENDING' &&
        existing !== 'REJECTED' &&
        existing !== 'ERROR' &&
        existing !== 'INTERRUPTED'
    ) {
        return 'PENDING';
    }
    if (incoming === 'NO_DATA' && existing === 'APPROVED') return 'NO_DATA';
    return existing;
};
